import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import axios from 'axios';
import {
  img_500,
  unavailable,
  unavailableLandscape,
} from '../../config/config';
import './ContentModal.css';
import { Button } from '@material-ui/core';
import YouTubeIcon from '@material-ui/icons/YouTube';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import Carousel from '../Carousel/Carousel';

import { UserState } from '../../UserContext';
import { doc, setDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import AuthModal from '../Authentication/AuthModal';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    width: '90%',
    height: '80%',
    backgroundColor: '#39445a',
    border: '1px solid #282c34',
    borderRadius: 10,
    color: 'white',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(1, 1, 3),
  },
}));

export default function ContentModal({ children, media_type, id }) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState();
  const [movie, setMovie] = useState();

  const { user, watchlist, setAlert } = UserState();
  const inWatchlist = watchlist.includes(
    content?.original_title || content?.original_name || content?.name
  );

  const addToWatchlist = async () => {
    const movieRef = doc(db, 'watchlist', user.uid);

    try {
      await setDoc(movieRef, {
        movies: watchlist
          ? [
              ...watchlist,
              content.original_title || content.original_name || content.name,
            ]
          : [content?.original_title || content.original_name || content.name],
      });
      console.log(content);
      setAlert({
        open: true,
        message: `${
          content.original_title || content.original_name || content.name
        } Added to the Watchlist!`,
        type: 'success',
      });
    } catch (error) {
      setAlert({
        open: true,
        mesage: error.message,
        type: 'error',
      });
    }
  };

  const removeFromWatchList = async () => {
    const movieRef = doc(db, 'watchlist', user.uid);

    try {
      await setDoc(
        movieRef,
        {
          movies: watchlist.filter(
            (watch) =>
              watch !==
              (content?.original_title ||
                content?.original_name ||
                content?.name)
          ),
        },
        { merge: true }
      );
      setAlert({
        open: true,
        message: `${
          content.original_title || content.original_name || content.name
        } Removed from the Watchlist!`,
        type: 'success',
      });
    } catch (error) {
      setAlert({
        open: true,
        mesage: error.message,
        type: 'error',
      });
    }
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const fetchData = async () => {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/${media_type}/${id}?api_key=${process.env.REACT_APP_API_KEY}&language=en-US`
    );

    setContent(data);
    // console.log(data);
  };

  const fetchVideo = async () => {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/${media_type}/${id}/videos?api_key=${process.env.REACT_APP_API_KEY}&language=en-US`
    );

    setMovie(data.results[0]?.key);
  };

  useEffect(() => {
    fetchData();
    fetchVideo();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div
        className="media"
        style={{ cursor: 'pointer' }}
        color="inherit"
        onClick={handleOpen}
      >
        {children}
      </div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          {content && (
            <div className={classes.paper}>
              <div className="ContentModal">
                <img
                  src={
                    content.poster_path
                      ? `${img_500}/${content.poster_path}`
                      : unavailable
                  }
                  alt={content.name || content.title}
                  className="ContentModal__portrait"
                />
                <img
                  src={
                    content.backdrop_path
                      ? `${img_500}/${content.backdrop_path}`
                      : unavailableLandscape
                  }
                  alt={content.name || content.title}
                  className="ContentModal__landscape"
                />
                <div className="ContentModal__about">
                  <span className="ContentModal__title">
                    {content.name || content.title} (
                    {(
                      content.first_air_date ||
                      content.release_date ||
                      '-----'
                    ).substring(0, 4)}
                    )
                  </span>
                  {content.tagline && (
                    <i className="tagline">{content.tagline}</i>
                  )}

                  <span className="ContentModal__description">
                    {content.overview}
                  </span>

                  <div>
                    <Carousel id={id} media_type={media_type} />
                  </div>

                  <Button
                    variant="outlined"
                    startIcon={<YouTubeIcon />}
                    style={{
                      marginTop: 10,
                      height: 40,
                      fontSize: 20,
                      fontWeight: 800,
                      fontStretch: 'semi-expanded',
                    }}
                    color="secondary"
                    target="__blank"
                    href={`https://www.youtube.com/watch?v=${movie}`}
                  >
                    Watch Trailer
                  </Button>
                  {user ? (
                    <Button
                      variant={inWatchlist ? 'contained' : 'outlined'}
                      startIcon={inWatchlist ? <RemoveIcon /> : <AddIcon />}
                      style={{
                        width: '100%',
                        height: 40,
                        marginTop: 10,
                        fontSize: 20,
                        fontWeight: 800,
                        fontStretch: 'semi-expanded',
                      }}
                      onClick={
                        inWatchlist ? removeFromWatchList : addToWatchlist
                      }
                    >
                      {inWatchlist ? 'Remove from Watchlist' : 'Watchlist'}
                    </Button>
                  ) : (
                    <AuthModal />
                  )}
                </div>
              </div>
            </div>
          )}
        </Fade>
      </Modal>
    </>
  );
}
